import $ from 'jquery/src/jquery'
import HeroAnimation from "../modules/hero-animation";

export default () => {
    const nodeSelectors = {
        container: '[js-popup="container"]',
        close: '[js-popup="close"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        // document.addEventListener("DOMContentLoaded", function () {
            // Check if popup has already been shown in this session
            if ( !isShown() ) {

                if( HeroAnimation().isAnimating() ) {
                    let video = document.querySelector(HeroAnimation().nodeSelectors.video)

                    HeroAnimation().waitUntilVideoPlaying(video).then(function() {
                        setTimeout(function() {
                            open()
                        }, 30000) // approximately 4s is duration of hero animation
                    });
                } else {
                    console.log('no animation')

                    setTimeout(function() {
                        open()
                    }, 30000) // whatever
                }
            }

            $(nodeSelectors.close).on('click', close)
        // })

        $(document).keyup(function(e) {
            if (e.key === "Escape") {
                close()
            }
        })
    }

    function open() {
        setSession()
        $(nodeSelectors.container).fadeIn()
        $('body, html').addClass('gl-no-scroll')
    }

    function close() {
        $(nodeSelectors.container).fadeOut()
        $('body, html').removeClass('gl-no-scroll')
    }

    function setSession() {
        sessionStorage.setItem("popupShown", "true")
    }

    function isShown() {
        return sessionStorage.getItem("popupShown") === "true"
    }

    return Object.freeze({
        init,
    })
}